<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  (closeTrigger)="onClose$.next()">

  <div class="__scaling-dialog-content">

    <zef-scrollbar maxHeight="calc(100vh - 48px)">

      <zui-autoscaling-settings-form
        [value]="autoscalingValue()"
        [serviceStackType]="state.serviceStack?.serviceStackTypeId"
        [supportsVerticalAutoscaling]="state.serviceStackTypesVersionsMap?.[state.serviceStack?.serviceStackTypeVersionId]?.serviceStackTypeVersion?.supportsVerticalAutoscaling !== false"
        [initialScalingType]="state.initialScalingType"
        [verticalLimits]="state.serviceStackTypesVersionsMap?.[state.serviceStack?.serviceStackTypeVersionId]?.serviceStackTypeVersion?.config?.verticalAutoscaling"
        [horizontalLimits]="state.serviceStackTypesVersionsMap?.[state.serviceStack?.serviceStackTypeVersionId]?.serviceStackTypeVersion?.config?.horizontalAutoscaling"
        [verticalPlaceholder]="state.serviceStackTypesVersionsMap?.[state.serviceStack?.serviceStackTypeVersionId]?.serviceStackTypeVersion?.config?.defaultAutoscaling?.verticalAutoscaling"
        [horizontalPlaceholder]="state.serviceStackTypesVersionsMap?.[state.serviceStack?.serviceStackTypeVersionId]?.serviceStackTypeVersion?.config?.defaultAutoscaling?.horizontalAutoscaling"
        [autoscalingProfiles]="state.serviceStackTypeConfig?.autoscalingProfiles"
        [currentServiceCpuMode]="state.currentServiceCpuMode"
        [isEditMode]="true"
        [isFreeUser]="state.isFreeUser"
        (validationChange)="isFormValid.set($event)"
        (valueChange)="autoscalingValue.set($event)"
      />

      <div class="__scaling-dialog-buttons">
        <div class="__scaling-dialog-card_button-wrap">
          <zef-progress-error full [key]="updateKey">
            <button
              class="c-button c-button--full"
              mat-flat-button
              type="button"
              color="accent"
              (click)="onSubmit$.next(autoscalingValue())"
              [disabled]="!isFormValid()">
              Apply changes
            </button>
          </zef-progress-error>
        </div>
      </div>

    </zef-scrollbar>

    <button
      class="__scaling-dialog-close-button"
      type="button"
      (click)="onClose$.next()"
      mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>

  </div>

</zef-dialog>
